var map = {
	"./404.png": 99411,
	"./404.webp": 15311,
	"./Thumbs.db": 1204,
	"./about/01.jpg": 90396,
	"./about/01.png": 43768,
	"./about/01.webp": 47472,
	"./about/02.jpg": 15563,
	"./about/02.webp": 90301,
	"./about/03.jpg": 19726,
	"./about/03.webp": 65586,
	"./about/04.png": 52165,
	"./about/04.webp": 88239,
	"./about/05.png": 34652,
	"./about/05.webp": 13356,
	"./about/06.png": 23383,
	"./about/06.webp": 7625,
	"./about/Thumbs.db": 34074,
	"./android-chrome-192x192.png": 99584,
	"./android-chrome-192x192.webp": 4336,
	"./android-chrome-512x512.png": 28248,
	"./android-chrome-512x512.webp": 98280,
	"./app/01.jpg": 67474,
	"./app/01.webp": 35706,
	"./app/02.jpg": 77373,
	"./app/02.webp": 96155,
	"./app/03.jpg": 38144,
	"./app/03.webp": 10808,
	"./app/04.png": 2811,
	"./app/04.webp": 67633,
	"./apple-touch-icon.png": 29111,
	"./apple-touch-icon.webp": 68457,
	"./bg/01.jpg": 61130,
	"./bg/01.png": 38574,
	"./bg/01.webp": 67456,
	"./bg/02.jpg": 71029,
	"./bg/02.png": 50053,
	"./bg/02.webp": 62125,
	"./bg/03.jpg": 63160,
	"./bg/03.webp": 90210,
	"./bg/04.jpg": 2955,
	"./bg/04.webp": 9791,
	"./bg/05.png": 79626,
	"./bg/05.webp": 3196,
	"./bg/06.png": 37057,
	"./bg/06.webp": 62585,
	"./bg/07.svg": 38578,
	"./bg/Thumbs.db": 80458,
	"./bg/bubbles.png": 3298,
	"./bg/bubbles.webp": 89290,
	"./blog/01.jpg": 57121,
	"./blog/01.webp": 9465,
	"./blog/02.jpg": 23862,
	"./blog/02.webp": 29788,
	"./blog/03.jpg": 79123,
	"./blog/03.webp": 8031,
	"./blog/04.jpg": 38816,
	"./blog/04.webp": 26594,
	"./blog/05.jpg": 64381,
	"./blog/05.webp": 82157,
	"./blog/06.jpg": 45426,
	"./blog/06.webp": 8448,
	"./blog/Thumbs.db": 20079,
	"./blog/backup-icon.svg": 6242,
	"./blog/cdn-icon.svg": 94955,
	"./blog/cicd-icon.svg": 87635,
	"./blog/cpu-ram-ssd-icon.svg": 44420,
	"./blog/docker-icon.svg": 93976,
	"./blog/ha-scalability-icon.svg": 15445,
	"./blog/hosting-icon.svg": 31002,
	"./blog/large/01.jpg": 1173,
	"./blog/large/01.webp": 47573,
	"./blog/large/02.jpg": 9098,
	"./blog/large/02.webp": 24520,
	"./blog/large/03.jpg": 76839,
	"./blog/large/03.webp": 32459,
	"./blog/local-offsite-backup-icon.svg": 79853,
	"./blog/mail-server-vps-icon.svg": 32011,
	"./blog/managed-vps-icon.svg": 34427,
	"./blog/microservices-icon.svg": 12468,
	"./blog/ports-reverse-proxy-icon.svg": 54734,
	"./blog/shared-to-vps-icon.svg": 90767,
	"./blog/ssh-icon.svg": 11270,
	"./blog/ssh.png": 13940,
	"./blog/subdomains-servers-icon.svg": 20630,
	"./blog/vps-use-cases-icon.svg": 68149,
	"./blog/vps-vs-shared-icon.svg": 88421,
	"./blog/website-vs-webapp-icon.svg": 43211,
	"./blog/woocommerce-icon.svg": 58796,
	"./blog/wordpress-icon.svg": 30959,
	"./blog/wordpress-popularity-icon.svg": 56937,
	"./cases/01.jpg": 68724,
	"./cases/01.webp": 84200,
	"./cases/02.jpg": 14787,
	"./cases/02.webp": 83957,
	"./cases/03.jpg": 55302,
	"./cases/03.webp": 79690,
	"./cases/05.jpg": 22160,
	"./cases/05.webp": 98628,
	"./cases/06.jpg": 36511,
	"./cases/06.webp": 46113,
	"./cases/07.jpg": 28450,
	"./cases/07.webp": 54438,
	"./cases/08.jpg": 82841,
	"./cases/08.webp": 19747,
	"./cases/09.jpg": 61788,
	"./cases/09.webp": 66048,
	"./cases/10.jpg": 13690,
	"./cases/10.webp": 61238,
	"./cases/large/01.jpg": 62944,
	"./cases/large/01.webp": 11160,
	"./cases/large/02.jpg": 76559,
	"./cases/large/02.webp": 72261,
	"./client/01.png": 41810,
	"./client/01.webp": 53888,
	"./client/02.png": 89993,
	"./client/02.webp": 32205,
	"./client/03.png": 65792,
	"./client/03.webp": 76642,
	"./client/04.png": 93823,
	"./client/04.webp": 79871,
	"./client/05.png": 40022,
	"./client/05.webp": 89628,
	"./client/06.png": 71789,
	"./client/06.webp": 32665,
	"./client/07.png": 8548,
	"./client/07.webp": 91230,
	"./client/08.png": 8739,
	"./client/08.webp": 3051,
	"./client/09.png": 18906,
	"./client/09.webp": 63144,
	"./client/10.png": 87568,
	"./client/10.webp": 28622,
	"./client/11.png": 3321,
	"./client/11.webp": 98345,
	"./client/12.png": 89314,
	"./client/12.webp": 87628,
	"./client/1280px-Docker_logo.svg.png": 36919,
	"./client/1280px-Docker_logo.svg.webp": 46139,
	"./client/13.png": 52971,
	"./client/13.webp": 61071,
	"./client/14.png": 60980,
	"./client/14.webp": 22290,
	"./client/15.png": 82109,
	"./client/15.webp": 25053,
	"./client/16.png": 98342,
	"./client/16.webp": 30800,
	"./client/GitHub_Logo.png": 91390,
	"./client/GitHub_Logo.webp": 40030,
	"./client/GitHub_Logo1.png": 88709,
	"./client/GitHub_Logo1.webp": 66589,
	"./client/Jenkins_logo_with_title.svg.png": 31087,
	"./client/Jenkins_logo_with_title.svg.webp": 957,
	"./client/Kubernetes-Logo.jpg": 87447,
	"./client/Kubernetes-Logo.webp": 44957,
	"./client/amazon_aws_logo_icon_168666.png": 33387,
	"./client/amazon_aws_logo_icon_168666.webp": 28205,
	"./client/docker-logo-blue.png": 7702,
	"./client/docker-logo-blue.webp": 98748,
	"./client/docker-logo-blue1.png": 31117,
	"./client/docker-logo-blue1.webp": 45679,
	"./client/download.png": 11987,
	"./client/download.webp": 54495,
	"./client/kisspng-computer-icons-pro-git-portable-network-graphics-i-git-book-pro-git-app-app-5b80546c0b1311.5417567715351368760454.jpg": 40829,
	"./client/kisspng-computer-icons-pro-git-portable-network-graphics-i-git-book-pro-git-app-app-5b80546c0b1311.5417567715351368760454.webp": 44091,
	"./client/kubernetes-horizontal-color.png": 13948,
	"./client/kubernetes-horizontal-color.webp": 17280,
	"./client/logo-logo-git-line-cheat-sheet-signage-cheating-mug-png-clipart.jpg": 97571,
	"./client/logo-logo-git-line-cheat-sheet-signage-cheating-mug-png-clipart.webp": 63878,
	"./client/m2i8d3H7b1K9b1H7 (1).png": 82924,
	"./client/m2i8d3H7b1K9b1H7 (1).webp": 86258,
	"./coming-bg.png": 48956,
	"./coming-bg.webp": 98442,
	"./coming-soon.png": 72068,
	"./coming-soon.webp": 79326,
	"./favicon-16x16.png": 10410,
	"./favicon-16x16.webp": 86560,
	"./favicon-32x32.png": 574,
	"./favicon-32x32.webp": 3640,
	"./favicon.ico": 30804,
	"./favicon.jpeg": 59868,
	"./favicon.webp": 56527,
	"./hero/01.png": 84885,
	"./hero/01.webp": 31065,
	"./hero/02.png": 99134,
	"./hero/02.webp": 14204,
	"./icon/01.svg": 12674,
	"./icon/02.svg": 67217,
	"./login.png": 19340,
	"./login.webp": 14982,
	"./maintenance.png": 5926,
	"./maintenance.webp": 27416,
	"./pattern/01.png": 38871,
	"./pattern/01.webp": 90129,
	"./pattern/02.png": 50140,
	"./pattern/02.webp": 12020,
	"./pattern/03.png": 67653,
	"./pattern/03.webp": 96727,
	"./pattern/04.png": 82986,
	"./pattern/04.webp": 58202,
	"./pattern/05.png": 33747,
	"./pattern/05.webp": 72229,
	"./portfolio/01.jpg": 37581,
	"./portfolio/01.webp": 69231,
	"./portfolio/02.jpg": 68354,
	"./portfolio/02.webp": 92590,
	"./portfolio/03.jpg": 60063,
	"./portfolio/03.webp": 88617,
	"./portfolio/04.jpg": 65428,
	"./portfolio/04.webp": 28464,
	"./portfolio/05.jpg": 53585,
	"./portfolio/05.webp": 54227,
	"./portfolio/06.jpg": 21382,
	"./portfolio/06.webp": 46578,
	"./portfolio/07.jpg": 11491,
	"./portfolio/07.webp": 71293,
	"./portfolio/large/01.jpg": 32081,
	"./portfolio/large/01.webp": 6287,
	"./portfolio/large/02.jpg": 90662,
	"./portfolio/large/02.webp": 63342,
	"./portfolio/large/03.jpg": 55363,
	"./portfolio/large/03.webp": 86089,
	"./portfolio/large/04.jpg": 40560,
	"./portfolio/large/04.webp": 34768,
	"./portfolio/large/05.jpg": 84013,
	"./portfolio/large/05.webp": 60531,
	"./portfolio/large/06.jpg": 35522,
	"./portfolio/large/06.webp": 26258,
	"./product-thumb/01.jpg": 70283,
	"./product-thumb/01.webp": 36817,
	"./product-thumb/02.jpg": 45116,
	"./product-thumb/02.webp": 58708,
	"./product/01.jpg": 2302,
	"./product/01.webp": 19994,
	"./product/02.jpg": 76009,
	"./product/02.webp": 23195,
	"./product/03.jpg": 30636,
	"./product/03.webp": 30392,
	"./product/04.jpg": 84983,
	"./product/04.webp": 55313,
	"./product/05.jpg": 74170,
	"./product/05.webp": 81686,
	"./product/06.jpg": 96773,
	"./product/06.webp": 19063,
	"./product/bags/bag-01-back.jpg": 33481,
	"./product/bags/bag-01-back.webp": 47375,
	"./product/bags/bag-01-front.jpg": 70127,
	"./product/bags/bag-01-front.webp": 82355,
	"./product/bags/bag-02-back.jpg": 93396,
	"./product/bags/bag-02-back.webp": 61872,
	"./product/bags/bag-02-front.jpg": 84568,
	"./product/bags/bag-02-front.webp": 73362,
	"./product/bags/bag-03-back.jpg": 82707,
	"./product/bags/bag-03-back.webp": 41133,
	"./product/bags/bag-03-front.jpg": 2785,
	"./product/bags/bag-03-front.webp": 70785,
	"./product/bags/bag-04-back.jpg": 73614,
	"./product/bags/bag-04-back.webp": 37638,
	"./product/bags/bag-04-front.jpg": 93866,
	"./product/bags/bag-04-front.webp": 79648,
	"./product/bags/bag-05-back.jpg": 83125,
	"./product/bags/bag-05-back.webp": 5707,
	"./product/bags/bag-05-front.jpg": 7683,
	"./product/bags/bag-06-back.jpg": 6752,
	"./product/bags/bag-06-front.jpg": 2956,
	"./product/bags/bag-07-back.jpg": 44959,
	"./product/bags/bag-07-front.jpg": 4949,
	"./product/bags/bag-08-back.jpg": 74122,
	"./product/bags/bag-08-front.jpg": 61358,
	"./product/bags/bag-09-back.jpg": 25281,
	"./product/bags/bag-09-front.jpg": 89703,
	"./product/bags/bag-10-back.jpg": 59491,
	"./product/bags/bag-10-front.jpg": 63633,
	"./product/kidsdress/dress-01-back.jpg": 47823,
	"./product/kidsdress/dress-01-back.webp": 82015,
	"./product/kidsdress/dress-01-front.jpg": 60261,
	"./product/kidsdress/dress-01-front.webp": 23939,
	"./product/kidsdress/dress-02-back.jpg": 23742,
	"./product/kidsdress/dress-02-back.webp": 31456,
	"./product/kidsdress/dress-02-front.jpg": 64122,
	"./product/kidsdress/dress-02-front.webp": 68834,
	"./product/kidsdress/dress-03-back.jpg": 39909,
	"./product/kidsdress/dress-03-back.webp": 1501,
	"./product/kidsdress/dress-03-front.jpg": 76627,
	"./product/kidsdress/dress-03-front.webp": 12273,
	"./product/kidsdress/dress-04-back.jpg": 36036,
	"./product/kidsdress/dress-04-back.webp": 34326,
	"./product/kidsdress/dress-04-front.jpg": 31944,
	"./product/kidsdress/dress-04-front.webp": 25232,
	"./product/kidsdress/dress-05-back.jpg": 65827,
	"./product/kidsdress/dress-05-back.webp": 63771,
	"./product/kidsdress/dress-05-front.jpg": 50321,
	"./product/kidsdress/dress-05-front.webp": 983,
	"./product/kidsdress/dress-06-back.jpg": 88642,
	"./product/kidsdress/dress-06-back.webp": 59468,
	"./product/kidsdress/dress-06-front.jpg": 53094,
	"./product/kidsdress/dress-06-front.webp": 21622,
	"./product/kidsdress/dress-07-back.jpg": 10137,
	"./product/kidsdress/dress-07-back.webp": 2649,
	"./product/kidsdress/dress-07-front.jpg": 90719,
	"./product/kidsdress/dress-07-front.webp": 661,
	"./product/kidsdress/dress-08-back.jpg": 40936,
	"./product/kidsdress/dress-08-back.webp": 39618,
	"./product/kidsdress/dress-08-front.jpg": 87732,
	"./product/kidsdress/dress-08-front.webp": 74836,
	"./product/kidsdress/dress-09-back.jpg": 80583,
	"./product/kidsdress/dress-09-back.webp": 55895,
	"./product/kidsdress/dress-09-front.jpg": 43293,
	"./product/kidsdress/dress-09-front.webp": 48795,
	"./product/mandress/dress-01-back.jpg": 60558,
	"./product/mandress/dress-01-back.webp": 67090,
	"./product/mandress/dress-01-front.jpg": 16810,
	"./product/mandress/dress-01-front.webp": 63332,
	"./product/mandress/dress-02-back.jpg": 3295,
	"./product/mandress/dress-02-back.webp": 8837,
	"./product/mandress/dress-02-front.jpg": 41045,
	"./product/mandress/dress-02-front.webp": 44377,
	"./product/mandress/dress-03-back.jpg": 90144,
	"./product/mandress/dress-03-back.webp": 712,
	"./product/mandress/dress-03-front.jpg": 70412,
	"./product/mandress/dress-03-front.webp": 76714,
	"./product/mandress/dress-04-back.jpg": 41929,
	"./product/mandress/dress-04-front.jpg": 22575,
	"./product/mandress/dress-05-back.jpg": 57490,
	"./product/mandress/dress-05-front.jpg": 15414,
	"./product/mandress/dress-06-back.jpg": 98483,
	"./product/mandress/dress-06-front.jpg": 86401,
	"./product/mandress/dress-07-back.jpg": 91559,
	"./product/mandress/dress-07-front.jpg": 46840,
	"./product/mandress/dress-08-back.jpg": 51085,
	"./product/mandress/dress-08-front.jpg": 85211,
	"./product/mandress/dress-09-back.jpg": 26246,
	"./product/mandress/dress-09-front.jpg": 40706,
	"./product/womandress/dress-01-back.jpg": 16632,
	"./product/womandress/dress-01-back.webp": 32408,
	"./product/womandress/dress-01-front.jpg": 66404,
	"./product/womandress/dress-01-front.webp": 70810,
	"./product/womandress/dress-02-back.jpg": 58029,
	"./product/womandress/dress-02-back.webp": 74391,
	"./product/womandress/dress-02-front.jpg": 67643,
	"./product/womandress/dress-02-front.webp": 51355,
	"./product/womandress/dress-03-back.jpg": 16742,
	"./product/womandress/dress-03-back.webp": 52546,
	"./product/womandress/dress-03-front.jpg": 68066,
	"./product/womandress/dress-03-front.webp": 68372,
	"./product/womandress/dress-04-back.jpg": 12363,
	"./product/womandress/dress-04-back.webp": 60017,
	"./product/womandress/dress-04-front.jpg": 70585,
	"./product/womandress/dress-04-front.webp": 9773,
	"./product/womandress/dress-05-back.jpg": 94476,
	"./product/womandress/dress-05-back.webp": 88740,
	"./product/womandress/dress-05-front.jpg": 11312,
	"./product/womandress/dress-05-front.webp": 6241,
	"./product/womandress/dress-06-back.jpg": 54305,
	"./product/womandress/dress-06-back.webp": 29331,
	"./product/womandress/dress-06-front.jpg": 90023,
	"./product/womandress/dress-06-front.webp": 16143,
	"./product/womandress/dress-07-back.jpg": 20330,
	"./product/womandress/dress-07-back.webp": 5102,
	"./product/womandress/dress-07-front.jpg": 38177,
	"./product/womandress/dress-07-front.webp": 36680,
	"./product/womandress/dress-08-back.jpg": 11903,
	"./product/womandress/dress-08-back.webp": 27325,
	"./product/womandress/dress-08-front.jpg": 81845,
	"./product/womandress/dress-08-front.webp": 49329,
	"./product/womandress/dress-09-back.jpg": 30560,
	"./product/womandress/dress-09-back.webp": 18912,
	"./product/womandress/dress-09-front.jpg": 29836,
	"./product/womandress/dress-09-front.webp": 81730,
	"./scroll-down-arrow.svg": 91469,
	"./site.webmanifest": 88265,
	"./svg/01.svg": 55987,
	"./svg/02.svg": 35232,
	"./svg/03.svg": 71185,
	"./svg/04.svg": 72686,
	"./svg/05.svg": 1119,
	"./svg/06.svg": 22092,
	"./svg/07.svg": 21037,
	"./team/01.jpg": 53760,
	"./team/01.png": 38212,
	"./team/01.webp": 5338,
	"./team/02.jpg": 67375,
	"./team/02.png": 91423,
	"./team/02.webp": 8539,
	"./team/03.jpg": 83090,
	"./team/03.png": 78134,
	"./team/03.webp": 15736,
	"./team/04.png": 18217,
	"./team/04.webp": 40657,
	"./team/Thumbs.db": 46200,
	"./testimonial/01.jpg": 60670,
	"./testimonial/01.webp": 61702,
	"./testimonial/02.jpg": 3753,
	"./testimonial/02.webp": 25959,
	"./testimonial/03.jpg": 65708,
	"./testimonial/03.webp": 72260,
	"./testimonial/04.jpg": 46903,
	"./testimonial/04.webp": 71989,
	"./testimonial/05.jpg": 83066,
	"./testimonial/05.webp": 26474,
	"./testimonial/06.jpg": 89317,
	"./testimonial/06.webp": 19467,
	"./testimonial/07.jpg": 62152,
	"./testimonial/07.webp": 79560,
	"./testimonial/08.jpg": 50291,
	"./testimonial/08.webp": 49081,
	"./thumbnail/01.jpg": 92393,
	"./thumbnail/01.webp": 11219,
	"./thumbnail/02.jpg": 49310,
	"./thumbnail/02.webp": 76946,
	"./thumbnail/03.jpg": 97147,
	"./thumbnail/03.webp": 28285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;